module.exports = "<!DOCTYPE html>\r\n<html>\r\n\r\n<body>\r\n    <h1>My First Heading</h1>\r\n    <p>My first paragraph.</p>\r\n</body>\r\n\r\n</html>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/html/codeExample.txt
 ** module id = ./src/parsers/html/codeExample.txt
 ** module chunks = 0
 **/